$(document).ready(function () {
  "use strict";
  $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  $('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  $(".menu > ul").before("<a href=\"#\" class=\"menu-mobile\">Navigation</a>");
  $(".menu > ul > li").hover(
    function (e) {
      if ($(window).width() > 980) {
        $(this).children("ul").fadeIn(150);
        e.preventDefault();
      }
    }, function (e) {
      if ($(window).width() > 980) {
        $(this).children("ul").fadeOut(150);
        e.preventDefault();
      }
    }
  );
  $('.menu-dropdown-icon a.Menu_top_link').click(function(e){
    if ($(window).width() < 981) {
      e.preventDefault();
      $(this).parent().siblings().removeClass(' active');
      $(this).parent().toggleClass(' active');
      $(this).siblings("ul").slideToggle(350);
      $(this).parent().siblings().children("ul").slideUp(350);
    }
  });
  $('.sub_child_links a.sub_link').click(function(e){
    if ($(window).width() < 981) {
      e.preventDefault();
      $(this).parent().siblings().removeClass(' active');
      $(this).parent().toggleClass(' active');
      $(this).siblings("ul").slideToggle(350);
      $(this).parent().siblings().children("ul").slideUp(350);
    }
  }); 
});